//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "HomeApp",
  components: {},
  props: ["tourist-active"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      list: []
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.fetchList();
  },
  destroyed: function destroyed() {},
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      this.loading = true;
      this.$http.post("/app/appPermitList", this.$qs.stringify({
        pageNum: 1,
        pageSize: 100
      })).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          _this.list = data.resData.list;
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    serverInsert: function serverInsert(item) {
      this.$http.post("/statistical/serverInsert", this.$qs.stringify({
        serviceId: item.id,
        appType: 9
      })).then(function () {}).catch(function () {});
    }
  },
  watch: {
    touristActive: function touristActive() {
      this.fetchList();
    }
  },
  filters: {}
};